export var SupportedFormat;

(function (SupportedFormat) {
  SupportedFormat["AbbreviatedLong"] = "ABBREVIATED_LONG";
  SupportedFormat["AbrevLongWithoutDay"] = "ABBREVIATED_LONG_DATE_WITHOUT_DAY";
  SupportedFormat["SlashedDate"] = "SLASHED_DATE";
  SupportedFormat["SlashedDateLongYear"] = "SLASHED_DATE_LONG_YEAR";
  SupportedFormat["TwoDigitMonthSlashedDate"] = "TWO_DIGIT_MONTH_SLASHED_DATE";
  SupportedFormat["DayNameMonthDate"] = "DAY_NAME_MONTH_DATE";
  SupportedFormat["DayNameShortMonthDate"] = "DAY_NAME_SHORT_MONTH_DATE";
  SupportedFormat["DayNameShort"] = "DAY_NAME_SHORT";
  SupportedFormat["DayOfMonth"] = "DAY_OF_MONTH";
  SupportedFormat["MonthNameShortDate"] = "MONTH_NAME_SHORT_DATE";
  SupportedFormat["MonthYear"] = "MONTH_YEAR";
  SupportedFormat["ShortMonthDate"] = "SHORT_MONTH_DATE";
  SupportedFormat["Time"] = "TIME";
  SupportedFormat["DayNameLongMonthSlashDay"] = "DAY_NAME_LONG_MONTH_SLASH_DAY";
  SupportedFormat["MonthNameYear"] = "MONTH_NAME_YEAR";
  SupportedFormat["MonthNameShort"] = "MONTH_NAME_SHORT";
})(SupportedFormat || (SupportedFormat = {}));